/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCompoundV3CometRewards extends Contract<ITestCompoundV3CometRewards> {
  rewardConfig: Call<(_cToken: AddressLike) => { token: string, rescaleFactor: BigNumber, shouldUpscale: boolean }, ITestCompoundV3CometRewards>
  'rewardConfig(address)': Call<(_cToken: AddressLike) => { token: string, rescaleFactor: BigNumber, shouldUpscale: boolean }, ITestCompoundV3CometRewards>
}

let ITestCompoundV3CometRewardsBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCompoundV3CometRewardsBytecode = '0x';
}

// prettier-ignore
export const ITestCompoundV3CometRewards = contract<ITestCompoundV3CometRewards>(ITestCompoundV3CometRewardsBytecode)`
  function rewardConfig(address _cToken) view returns (tuple(address token, uint64 rescaleFactor, bool shouldUpscale) rewardConfig_)
`;